import * as TextileFiltrator from '@Stores/TextileFiltrator';
import { collectionsStore, updateTextileGroups } from './stores';
import filterCollections from './helpers/filterCollections';

function applyFilters(): void {
  const collections = filterCollections();

  collectionsStore.set(collections);
  updateTextileGroups();
  TextileFiltrator.applyFilters();
}

export default applyFilters;
